module.exports = __webpack_public_path__ + "img/r-233.45d103e1.jpg";